<template>
  <div class="content" style="overflow:auto;height:100%">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item class="buildItem">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>
        <a to="/build">质量监控</a>
      </el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="build-CURD">
      <div class="build-bar">
        <img class="hand" src="../../assets/image/back.png" alt @click="$router.go(-1)" />
        <!-- <i style="margin-left:50px;color:#65B1FF" class="el-icon-back" @click="$router.go(-1)"></i> -->
        <el-col
          class="hand"
          :span="3"
          style="text-align: left;padding-left: 20px;display: flex;color:#65B1FF"
          v-if="tabTitle==1"
        >上传参建班组统计</el-col>
        <el-col
          class="hand"
          :span="3"
          style="text-align: left;padding-left: 20px;display: flex;color:#65B1FF"
          v-if="tabTitle==2"
        >未上传班组统计</el-col>
        <el-col
          class="hand"
          :span="3"
          style="text-align: left;padding-left: 20px;display: flex;color:#65B1FF"
          v-if="tabTitle==3"
        >今日新增班组统计</el-col>
      </div>
      <div class="build-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="100%"
          :row-style="{height:'70px'}"
          :cell-style="{padding:'5px 0'}"
          stripe
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="参建单位">
            <template slot-scope="scope">
              <span>{{scope.row.entName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="班组名称">
            <template slot-scope="scope">
              <span>{{scope.row.teamsName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="在职人员">
            <template slot-scope="scope">
              <span>{{ scope.row.zz }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="累计出勤">
            <template slot-scope="scope">
              <span>{{ scope.row.sum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当月出勤" v-if="tabTitle==1">
            <template slot-scope="scope">
              <span>{{ scope.row.xum }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="上传状态">
            <template slot-scope="scope">
              <div v-if="scope.row.jgStatus==0">未上传</div>
              <div v-if="scope.row.jgStatus==1">
                <div style="color:red">上传失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.jgReason}}</div>
                </el-tooltip>
                <!-- <el-tooltip placement="bottom" style="text-algin:center">
                  <div slot="content">时间:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.jgReason}}</div>
                </el-tooltip> -->
              </div>
              <div v-if="scope.row.jgStatus==2">
                <div style="color:#67C23A">上传成功</div>
                <!-- <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.jgReason}}</div>
                </el-tooltip> -->
              </div>
              <div v-if="scope.row.jgStatus==3">
                <div style="color:red">上传失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.jgReason}}</div>
                </el-tooltip>
                <!-- <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.jgReason}}</div>
                </el-tooltip> -->
              </div>
              <div v-if="scope.row.jgStatus==4">
                <div style="color:#67C23A">上传成功</div>
                <!-- <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.jgReason}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.jgReason}}</div>
                </el-tooltip> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="getInfo(scope.row)" style="color:##4D7BF4">查看</el-button>
            </template>
          </el-table-column> -->

          <!-- 编辑窗口 -->
          <!-- <el-dialog
            title="编辑"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="名称：">
                <el-input v-model="editForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="楼号：">
                <el-input v-model="editForm.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-input v-model="editForm.adddress" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属：">
                <el-input v-model="editForm.people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="人数：">
                <el-input v-model="editForm.contract" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-dialog>-->
        </el-table>
      </div>
      <!-- 分页展示 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10,20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      dataText: '数据加载中...',
      tabTitle: '',
      num: {
        cjCount: 0,
        glCount: 0,
        grCount: 0
      },
    }
  },
  mounted() {
    if (util.session.get('roleId') != '4') {
      this.projectId = util.session.get('proId')
    } else {
      this.projectId = util.session.get('groupId')
    }
    this.tabTitle = this.$route.params.status
    //console.log(this.tabTitle)
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    this.getData()
  },
  methods: {
   
    //获取数据
    getData() {
      var that = this
      // if (this.tabTitle == 1 || this.tabTitle == 2) {
      myHttp.getTeamsPageListByCondition({
          status: this.tabTitle,
          projectId: this.projectId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              //console.log(resp)
              // var num = resp.data.data
              var list = resp.data.data.pageInfo.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
              }
              // that.num = num
              that.tableData = list
              that.totalItems = resp.data.data.pageInfo.total
              if (that.tableData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {}
        )
      
    },
    // 编辑数据
    getInfo(row) {
      let that = this
      console.log(row)
      setTimeout(function() {
        that.$router.push({
          name: 'productMan',
          params: { id: row.teamsId, name: row.teamsName, projectId: that.projectId }
        })
      }, 0)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    }
  }
}
</script>
<style scoped>
.build-bar span {
  margin-left: 10px;
  /* margin-right: 40px */
  font-size: 18px;
  position: relative;
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  /* background: #fff; */
  width: 100%;
  /* margin-top: 20px; */
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.build-table {
  height: calc(100% - 160px);
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-table {
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: calc(100% - 150px);
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: 2px solid #78bcf7;
}
.hand {
  cursor: pointer;
}
img {
  margin-left: 1vh;
}
/* .el-table__body-wrapper {
  overflow: auto;
  height: calc(100% - 50px);
  position: relative;
} */
</style>
<style>
.head-type span {
  margin-left: 0 !important;
}
</style>
<style>
@import '../../assets/css/common.css';
</style>